import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

/**
 * Composable for mobile detection using Tailwind breakpoints
 * @returns {object} Object containing mobile detection utilities
 */
export function useMobileDetection() {
  const breakpoints = useBreakpoints(breakpointsTailwind);

  // Mobile: screens smaller than md (768px)
  // Note: breakpoints.smaller() already returns a ComputedRef<boolean>
  const isMobile = breakpoints.smaller('md');

  // Tablet: screens between md and lg
  const isTablet = breakpoints.between('md', 'lg');

  // Desktop: screens lg and larger
  const isDesktop = breakpoints.greaterOrEqual('lg');

  // Small mobile: screens smaller than sm (640px)
  const isSmallMobile = breakpoints.smaller('sm');

  return {
    breakpoints,
    isMobile,
    isTablet,
    isDesktop,
    isSmallMobile,
  };
}
